import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";
import { Credentials } from "../../assets/features/Credentials";

const firebaseConfig = {
    apiKey: Credentials.FIREBASE_API_KEY,
    authDomain: Credentials.FIREBASE_AUTH_DOMAIN,
    projectId: Credentials.FIREBASE_PROJECT_ID,
    storageBucket: Credentials.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: Credentials.FIREBASE_MESSAGING_SENDER_ID,
    appId: Credentials.FIREBASE_APP_ID,
    measurementId: Credentials.FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

// Initialize Firebase services
const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();
const googleProvider = new firebase.auth.GoogleAuthProvider();

// Firebase Analytics intentionally NOT initialized: it double-tracked GA4
// (its own G-QS983XK3GP config next to GTM's G-PQLFDS1XPF) and its gtag
// wrapper broke consent updates. The `analytics` export was never imported.
const analytics = null;

export { auth, firestore, storage, functions, googleProvider, analytics };
export const db = firestore;
export const app = firebase.app();
